module.exports = __webpack_public_path__ + "assets/images/scrolly-network/mobile.svg?v=dca9e82d";